import React from 'react';
import classNames from 'classnames';
import { useTranslation } from '../../../translations';
import { useLanguageControls } from '../../../hooks/useLanguageControls';
import { languages } from '../../../translations';
import { isString } from 'lodash';

const Match3Controls = React.forwardRef(function ThreeControls({ isVisible, list, isWeb }, ref) {
  const { t } = useTranslation();
  const { language } = useLanguageControls();
  const isArabic = language === languages.ar;

  const formatCount = (count) => {
    if (isString(count) && count.includes('/') && isArabic) {
      const parts = count.split('/');
      return `${parts[1]}/${parts[0]}`;
    }
    return count;
  };

  const items = list.map(({ title, count }, index) => (
    <div key={'match3__controls-item-' + index} className={`match3__controls-item`}>
      <div className={'match3__controls-item-title'}>{t(title)}</div>
      <div className={'match3__controls-item-count'}>{formatCount(count)}</div>
    </div>
  ));

  return (
    <div
      className={classNames(`match3__controls ${isWeb ? '' : 'app_margin'}`, isVisible && 'match3__controls_visible')}
      ref={ref}
    >
      <div className={'match3__controls-level'}>{items[0]}</div>
      <div className={'match3__controls-score'}>{items.splice(1)}</div>
    </div>
  );
});
export default Match3Controls;
Match3Controls.propTypes = {};
